import { useEffect, useState } from 'react';
import { Modal } from '@/components/dialogs/Modal';
import { AsyncButton } from '@/components/common/AsyncButton';
import { Select2AsyncMulti } from '@/components/forms/Select2AsyncMulti';
import { makeLoginsByGroupsFetcher } from '@/api/services/swapFreeControl';

interface Props {
  show: boolean;
  group: string | null;
  current: number[]; // currently-effective exception logins for this group
  onSave: (group: string, logins: number[]) => void;
  onClose: () => void;
}

// Edit the excluded (exception) logins for one group. Pre-seeds the current
// logins and loads candidates from logins-by-groups for that group.
export function EditExceptionsDialog({ show, group, current, onSave, onClose }: Props) {
  const [values, setValues] = useState<string[]>([]);

  useEffect(() => {
    if (show) setValues(current.map(String));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, group]);

  if (!group) return null;

  const fetch = makeLoginsByGroupsFetcher([group]);

  const save = () => {
    onSave(group, values.map((v) => Number(v)));
  };

  return (
    <Modal
      show={show}
      title="Excluded Logins"
      onClose={onClose}
      footer={
        <>
          <button type="button" className="btn btn-light btn-sm" onClick={onClose}>Cancel</button>
          <AsyncButton className="btn btn-primary btn-sm" onClick={save}>Save</AsyncButton>
        </>
      }
    >
      <p className="text-muted mb-2">Group: <span className="fw-semibold">{group}</span></p>
      <Select2AsyncMulti
        placeholder="Select Exceptions"
        fetch={fetch}
        value={values}
        onChange={setValues}
      />
    </Modal>
  );
}
